import {svgIconWrapper} from '../svg-icon-wrapper';

import ClockArrowRegular from './clock-arrow-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ClockArrowRegular {...props} />;
}
SvgComponent.iconName = 'clockArrowRegular';

export const ClockArrowRegularIcon = svgIconWrapper(SvgComponent);
